<template>
  <div class="footer">
    <div class="footer-content zh_HK">
      <div class="top-content">
        <p>
          <a target="_blank" :href="config.userProtocolLink">服務條款</a>
          <a target="_blank" :href="config.privacyLink">隱私協議</a>
        </p>
      </div>

      <div class="bottom-content">
        <div class="l-logo" style="margin-right: 10px">
          <img src='@/assets/images/active/snail/fifth/hk/icon_fz.png' alt="图片加载失败">
        </div>
        <div class="r-text">
          <p>*思耐爾數位為最強蝸牛在台港澳的授權代理商。</p>
          <p>*本遊戲因涉及暴力、不當言語之情節，依遊戲軟體分級管理辦法分類為輔12級。</p>
          <p>*注意使用時間，避免沉迷於遊戲。</p>
          <p>*本遊戲為免費遊戲，但遊戲內另提供購買虛擬遊戲幣、物品等付費服務，請依個人興趣及能力適度消費。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GAME_COPYRIGHT } from "@/config/constant";

export default {
  name: "Footer",
  components: {},
  created() {
    this.year = new Date().getFullYear();
    if (!this.gameName) {
      throw new Error("请传入gameName");
    }
    this.config = this.GAME_COPYRIGHT[this.gameName];
  },
  data() {
    return {
      GAME_COPYRIGHT: GAME_COPYRIGHT,
      year: 0,
      config: {}
    };
  },
  props: {
    gameName: {
      type: String, // 传入参数：snail | tideng | timeTravel | servitor | hjwq | qscy
      required: true,
      default: ""
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/5thReport/components/Footer/index.vue